<template>
  <div class="chat-input-container">
    <input 
      type="text" 
      class="chat-input" 
      :placeholder="placeholder" 
      v-model="inputValue" 
      @keyup.enter="sendMessage"
      :disabled="disabled"
    >
    <button class="send-btn" @click="sendMessage" :disabled="disabled">
      <i v-if="icon" :class="icon"></i>
      <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"></line>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ChatInput',
  props: {
    placeholder: {
      type: String,
      default: '输入消息...'
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  watch: {
    value(newVal) {
      this.inputValue = newVal;
    },
    inputValue(newVal) {
      this.$emit('input', newVal);
    }
  },
  methods: {
    sendMessage() {
      console.log('ChatInput: 发送按钮被点击或Enter键被按下');
      console.log('ChatInput: 消息内容:', this.inputValue);
      console.log('ChatInput: 禁用状态:', this.disabled);
      
      // 只检查是否禁用，不检查消息是否为空，让父组件处理
      if (!this.disabled) {
        // 直接使用本地存储的值，而不是computed属性
        const content = this.inputValue || '';
        console.log('ChatInput: 发送事件被触发，内容长度:', content.length);
        this.$emit('send', content);
        
        // 发送后不立即清空，由父组件控制
      } else {
        console.log('ChatInput: 由于禁用状态无法发送');
      }
    },
    
    // 提供清空输入框的方法，供父组件调用
    clearInput() {
      console.log('ChatInput: 清空输入框');
      this.inputValue = '';
    }
  }
}
</script>

<style scoped>
.chat-input-container {
  display: flex;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border-color, rgba(203, 213, 225, 0.5));
  background-color: var(--input-bg, white);
  transition: border-color 0.3s, box-shadow 0.3s;
}

.chat-input-container:focus-within {
  border-color: var(--primary-color, #4361ee);
  box-shadow: 0 0 0 2px rgba(67, 97, 238, 0.2);
}

.chat-input {
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  outline: none;
  font-size: 0.9375rem;
  background-color: transparent;
  color: var(--text-color, #1f2937);
}

.chat-input::placeholder {
  color: var(--text-tertiary, #9ca3af);
}

.chat-input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  border: none;
  background-color: var(--primary-color, #4361ee);
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}

.send-btn:hover:not(:disabled) {
  background-color: var(--primary-hover, #3a56d4);
}

.send-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.send-btn svg, .send-btn i {
  width: 18px;
  height: 18px;
}

/* 暗色主题支持 */
[data-theme="dark"] .chat-input-container {
  background-color: var(--input-bg, #333);
  border-color: var(--border-color, #444);
}

[data-theme="dark"] .chat-input {
  color: var(--text-color, #e5e7eb);
}

[data-theme="dark"] .chat-input::placeholder {
  color: var(--text-tertiary, #6b7280);
}
</style> 